import { Container, Group } from '@mantine/core';
import Alert from '../../component/common/alert';
import Loader from '../../component/common/loader';
import LoginBranding from '../login/auth/components/branding';
import { useGetProjectDetails } from '../login/hooks';
import ResetPasswordForm from './component/form';
import { resetPasswordContainerStyle } from './styles';
import { useMediaQuery } from '@mantine/hooks';
import { useProcessSetNewPassword, useSetPasswordForm } from './hooks';
import { useGetPageSetPassword, useGetPageSetPasswordFooter } from '../project/pages/hooks';
import { ContainerMainStyles, DivContent, FlexDirection, GroupContent } from '../auth-styles';

export default function ResetPassword() {
  const { isLoading, error, data } = useGetProjectDetails();
  const { data: passwordPageData, isLoading: setPasswordIsLoading } = useGetPageSetPassword();

  const largeScreen = useMediaQuery('(min-width: 800px)');
  const hookForm = useSetPasswordForm();
  const hookSetPassword = useProcessSetNewPassword();
  const footerData = useGetPageSetPasswordFooter();

  if (isLoading || setPasswordIsLoading) {
    return <Loader />;
  }

  if (error) {
    return <Alert message="An error occured while loading the page..." color="red" />;
  }

  return (
    <Container fluid={data && !passwordPageData?.content} sx={data && !passwordPageData?.content ? resetPasswordContainerStyle : {}} style={ data && !passwordPageData?.content ? {} : ContainerMainStyles}>
      <Group
        direction={FlexDirection(passwordPageData)}
        align={'center'}
        style={GroupContent}
        position="center"
        spacing={largeScreen ? 50 : 0}
      >
        {
          passwordPageData?.content && <div style={DivContent} dangerouslySetInnerHTML={{ __html: passwordPageData.content }} />
        }
        {
          (data && !passwordPageData?.content) && <LoginBranding project={data}/>
        }
        <ResetPasswordForm hookForm={hookForm} onSetPassword={hookSetPassword}/>
      </Group>
      {footerData?.data?.content && <div dangerouslySetInnerHTML={{ __html: footerData?.data?.content ?? '' }} />}
    </Container>
  );
}
